<template>
  <v-sheet color="grey lighten-1 py-8 py-md-10">
    <v-container class="pt-0">
      <div class="d-flex justify-center">
        <TitleWidget>Produtos</TitleWidget>
      </div>
      <div class="py-10">
        <SearchProductsWidget :path="path" />
      </div>
      <LoadingWidget v-if="loading" />
      <transition name="fade">
        <div v-if="!loading">
          <v-row
            justify="center"
            justify-md="start"
            v-if="items.length"
            class="mt-sm-8 mt-3"
          >
            <template v-for="(item, keyItems) in items">
              <v-col
                class="d-flex justify-center"
                v-if="item.img && item.title"
                :key="keyItems"
                cols="8"
                sm="5"
                md="3"
              >
                <ProductCard v-bind="item" />
              </v-col>
            </template>
          </v-row>
          <v-alert v-else-if="!loading" color="info" width="100%">
            <div
              class="
                d-flex
                justify-sm-space-between
                align-center
                flex-wrap
                justify-center
              "
            >
              <div class="d-flex align-center">
                <v-icon class="mr-2" color="white">
                  fas fa-exclamation-circle
                </v-icon>
                <span class="white--text">Nenhum produto encontrado!</span>
              </div>
              <v-btn
                text
                color="white"
                to="/produtos"
                class="text-none rounded-0 mt-3 mt-sm-0"
              >
                Todos os produtos
              </v-btn>
            </div>
          </v-alert>

          <v-pagination
            class="mt-10"
            v-model="page"
            :length="pagesLength"
            :total-visible="pagesLength"
            v-if="pagesLength > 1"
          ></v-pagination>
        </div>
      </transition>
    </v-container>
  </v-sheet>
</template>

<script>
import ProductCard from "../components/cards/ProductCard.vue";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import SearchProductsWidget from "../components/widgets/SearchProductsWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import { formatToURL } from "../utils/formatToURL";

const _config = {
  mod: "products",
  path: "/produtos",
  itemsPerPage: 16,
};

export default {
  data: () => ({
    items: [],
    loading: true,
    totalItems: "",
    path: _config.path,
    itemsPerPage: _config.itemsPerPage,
  }),
  computed: {
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;
        return this.$router.push({ query });
      },
    },
    pagesLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    categories() {
      return this.$rest("categories").list;
    },

    getCategoryIdFromUrl() {
      const params = this.$route.params.category;
      const categoryFiltered = this.categories.filter(
        (category) => formatToURL(category.title) === params
      );

      let categoryId = null;
      if (categoryFiltered.length) categoryId = categoryFiltered[0].id;

      return categoryId;
    },
  },
  created() {
    this.getItems();

    this.$rest("categories").get();
  },
  methods: {
    getItems() {
      this.loading = true;

      const params = {
        returnTotalItems: 1,
        itemsPerPage: this.itemsPerPage,
      };

      if (this.getCategoryIdFromUrl)
        params.category = this.getCategoryIdFromUrl;
      if (this.$route.query.q) params.search = this.$route.query.q;
      if (this.page) params.page = this.page;

      this.$rest(_config.mod)
        .get({
          params,
          keepCache: true,
          save: (state, { totalItems, list }) => {
            this.items = list.map(({ id, title, imgs, category }) => ({
              id,
              title,
              to: `${_config.path}/${formatToURL(category.title)}/${formatToURL(
                title
              )}-${id}`,
              img: imgs.featured ? this.files + imgs.featured : undefined,
            }));

            this.totalItems = totalItems;

            if (!list.length && this.page > 1) this.page = 1;
          },
        })
        .then(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.getItems();
    },
    getCategoryIdFromUrl() {
      this.getItems();
    },
    page() {
      this.getItems();
    },
  },
  components: {
    TitleWidget,
    ProductCard,
    LoadingWidget,
    SearchProductsWidget,
  },
};
</script>

<style lang="scss">
@media (max-width: 600px) {
  .v-pagination__item,
  .v-pagination__navigation {
    font-size: 16px;
    height: 40px !important;
    margin: 0.3rem;
    min-width: 40px;
    padding: 0 5px;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
    width: auto !important;
  }
}
</style>
